<template lang="pug">
.metaContainer(v-loading="loading" element-loading-text="数据更新中...")
  .title 业务模型
  .oper
    el-button(type="primary" plain size="small" @click="updateTable") 从数据库加载
    el-button(size="small" :disabled="multipleSelection.length===0" @click="updateAll") 批量更新业务模型
    el-button(size="small"  :disabled="multipleSelection.length===0" @click="metaDelete") 删 除
    el-button(size="small" type="primary"  @click="openModelMaintain") 新建业务模型
  .list
    vxe-table(border round resizable size="medium" show-overflow keep-source ref="xTable" :data="tableData"
      @checkbox-all="selectAllEvent"
      @checkbox-change="selectChangeEvent"
      :edit-config="{trigger: 'manual', mode: 'row', autoClear:false}")
      vxe-column(type="checkbox" width="60",align="center")
      vxe-column(type="seq" width="50",align="center",title="序号")
      vxe-column(field="tableName",align="left", title="业务模型编号", sortable )
      vxe-column(field="businessName" ,align="left",title="业务模型名称" :edit-render="{}" sortable )
        template(#edit="{ row }")
          vxe-input(v-model="row.businessName" type="text" size="medium" clearable)
      vxe-column(field="tableDesc",align="left", title="描述" :edit-render="{}" )
        template(#edit="{ row }")
          vxe-input(v-model="row.tableDesc" type="text" size="medium" clearable)
      // vxe-column(field="tableDesc",align="center", title="删除行为" :edit-render="{}" )
      //   template(#default="{ row }")
      //     el-radio-group(v-model="row.isLogicDelete")
      //       el-radio(:label="1" :disabled="true") 逻辑删除
      //       el-radio(:label="0" :disabled="true") 物理删除
      //   template(#edit="{ row }")
      //     el-radio-group(v-model="row.isLogicDelete")
      //       el-radio(:label="1") 逻辑删除
      //       el-radio(:label="0") 物理删除
      vxe-column(field="" ,width="300", align="center",title="操作" v-slot="{row}")
        template(v-if="$refs.xTable.isActiveByRow(row)")
          vxe-button(type="primary" size="mini" @click="saveRowEvent(row)") 保 存
          vxe-button( size="mini" @click="cancelRowEvent(row)") 取 消
        template(v-else)
          vxe-button( size="mini" status="success" @click="copeRowEvent(row)") 复 制
          vxe-button( size="mini" status="primary" @click="editRowEvent(row)") 编 辑
          vxe-button( size="mini" @click="updateRow(row)") 更 新
          vxe-button( size="mini" @click="jumpDetail(row)") 设 计
  compontent(:is="dataDialog" ref="dataDialog" @initTree="initTree" )
</template>

<script>
import "@/CommonDP/utils/vxe-table/index.js";
import metadataService from "@/CommonDP/service/metadata-service.js";
import detailMetaDialog from "./dialog/detailMetaDialog.vue";
import copeModelDialog from "./dialog/copeModelDialog.vue";
import modelMaintain from "./modelMaintain.vue";
export default {
  props: {
    clickNode: {
      type: Function,
      default() {}
    },
    curNode: {
      type: Object,
      default() {
        return {};
      }
    },
    treeRef: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dataDialog: "",
      tableData: [],
      formData: {},
      loading: false,
      multipleSelection: []
    };
  },
  methods: {
    queryChildrenData(data) {
      this.formData = data;
      this.queryDynMetaListByGroupID();
    },
    async queryDynMetaListByGroupID() {
      const res = await metadataService.queryDynMetaListByGroupID(this.formData.groupId);
      this.tableData = res.data || [];
    },
    selectAllEvent({ checked }) {
      const records = this.$refs.xTable.getCheckboxRecords();
      this.multipleSelection = records;
    },
    selectChangeEvent({ checked }) {
      const records = this.$refs.xTable.getCheckboxRecords();
      this.multipleSelection = records;
    },
    // 复制业务模型
    async copeRowEvent(row) {
      this.dataDialog = copeModelDialog;
      await this.$nextTick();
      this.$refs.dataDialog.openDialog(row);
    },
    editRowEvent(row) {
      const $table = this.$refs.xTable;
      $table.setActiveRow(row);
    },
    initTree(groupId) {
      this.queryChildrenData(this.formData);
      this.$emit("initTree", false, groupId);
    },
    async saveRowEvent({ metaId, businessName, tableDesc }) {
      console.log(metaId, businessName, tableDesc);
      const params = { metaId, businessName, tableDesc, isLogicDelete: 1 };
      await metadataService.dynMetaUpdate(params);
      this.$success("操作成功");
      const $table = this.$refs.xTable;
      $table.clearActived();
    },
    cancelRowEvent(row) {
      const $table = this.$refs.xTable;
      $table.clearActived().then(() => {
        // 还原行数据
        $table.revertData(row);
      });
    },
    metaDelete() {
      this.$confirm(`确认删除选中的数据吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.loading = true;
          const tableNameList = this.multipleSelection.map((e) => e.tableName);
          await metadataService.dynMetaDelete(tableNameList);
          this.$emit("initTree");
          this.queryChildrenData(this.formData);
          this.$success("操作成功");
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 更新
    async updateRow(row) {
      const tableNameList = [row.tableName];
      this.finalUpdate(tableNameList);
    },
    // 更新选中的业务模型
    async updateAll() {
      const tableNameList = this.multipleSelection.map((e) => {
        return e.tableName;
      });
      this.finalUpdate(tableNameList);
    },
    async finalUpdate(params) {
      this.loading = true;
      try {
        await metadataService.updateMeta(params);
        this.$emit("initTree");
        this.queryChildrenData(this.formData);
        this.$success("操作成功");
        this.multipleSelection = [];
      } finally {
        this.loading = false;
      }
    },
    // 更新统计表数据
    update() {
      this.queryDynMetaListByGroupID();
    },
    updateTable() {
      this.$emit("openTypeDialog", this.formData, "correlation");
    },
    async openModelMaintain(row) {
      this.dataDialog = modelMaintain;
      await this.$nextTick();
      this.$refs.dataDialog.openDialog(this.formData);
    },
    // 业务模型详情
    async showDetailRow(row) {
      this.dataDialog = detailMetaDialog;
      await this.$nextTick();
      this.$refs.dataDialog.openDialog(row.metaId, row.businessName);
    },
    // 业务模型详情
    async jumpDetail(row) {
      this.curNode.expand();
      const target = this.curNode.childNodes.find((node) => node.data.groupId === row.tableName);
      this.clickNode(target.data, target);
      this.treeRef.setCurrentKey(target.data.groupId);
    }
  }
};
</script>

<style lang="scss" scoped>
.metaContainer {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .title {
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    padding: 10px 0;
    line-height: 25px;
    color: var(--key-color);
    font-weight: 600;
    font-size: 16px;
  }

  .oper {
    padding: var(--middle-space) 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .list {
    height: calc(100% - 80px);
    overflow-y: auto;
  }
}

/deep/.vxe-table--render-default.vxe-editable .vxe-body--column,
.vxe-table--render-default.vxe-editable .vxe-body--column.col--actived {
  padding: 11px 0;
}
</style>
